<template>
    <v-dialog v-model="file_modal_show" width="968">
        <v-card>
            <v-card-text>
                <div>
                    <v-img v-if="file_modal_item.mime=='jpg' || file_modal_item.mime=='jpeg' || file_modal_item.mime=='png' || file_modal_item.mime=='svg' || file_modal_item.mime=='gif' || file_modal_item.mime=='webp'" :src="file_modal_item.url" :title="`Dateiname: ${file_modal_item.name}`" alt="Bild nicht aufrufbar" contain></v-img>
                    <object v-else :data="file_modal_item.url" type="application/pdf" class="pdfpreview" style="width:100%;height:90vh">
                        <iframe :src="file_modal_item.url" class="pdfpreview" id="pdfpreview_iframe">
                            <p>Wir können Dir auf diesem Gerät keine PDFs anzeigen; bitte die Datei stattdessen herunterladen: <a :href="file_modal_item.url" target="_blank" download>PDF herunterladen</a>.</p>
                        </iframe>
                    </object>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>


<script>
export default {
    name: 'LightBox',

    data () {
        return {
            file_modal_show: false
        }
    },

    props: ['file_modal_item'],

    watch: {
        file_modal_item (val) {
            if(val){
                // console.log('file_modal_item :>> ', this.file_modal_item, val);
                this.file_modal_show = true;
            }
        }
    }
}
</script>